import cn from "classnames";
import React, { useState } from "react";
import { ProgressBar } from ".";

export default (props) => {
    return (
        <div className="card mb-3">
            <div className="card-header">
                Длительность запросов. Макс - <b>{props.requestsDuration.maxDuration}с</b>;&nbsp; Сред -&nbsp;
                <b>{props.requestsDuration.averageDuration}с</b>
            </div>
            <div className="card-body">
                {props.requestsDuration.topUsers.map((userData) => (
                    <UserRequestsDurationData
                        key={userData.user}
                        {...userData}
                        overallMaxDuration={props.requestsDuration.maxDuration}
                        overallAvgDuration={props.requestsDuration.averageDuration}
                    />
                ))}
            </div>
        </div>
    );
};

const UserRequestsDurationData = (props) => {
    const [opened, setOpened] = useState(false);
    return (
        <div key={props.user} className="mb-2">
            <div className="row">
                <div className="col-sm-3 ellipsis">
                    <div
                        className={cn("d-inline-block collapse-btn", {
                            "collapse-btn--down": !opened,
                            "collapse-btn--up": opened,
                        })}
                        onClick={() => setOpened(!opened)}
                    />
                    <span title={props.user}>{props.user}</span>
                </div>
                <div className="col-sm-9 d-flex align-items-center">
                    <ProgressBar title="Макс:" maxCount={props.overallMaxDuration} count={props.maxDuration} />
                </div>
                <div className="offset-sm-3 col-sm-9 d-flex align-items-center mb-2">
                    <ProgressBar title="Сред:" maxCount={props.overallAvgDuration} count={props.averageDuration} />
                </div>
            </div>
            {opened && (
                <table className="table table-sm">
                    <thead>
                        <tr>
                            <td className="text-muted small">Запрос</td>
                            <td className="text-muted small">Макс. длительность</td>
                            <td className="text-muted small">Сред. длительность</td>
                        </tr>
                    </thead>
                    <tbody>
                        {props.topRequests.map((item) => (
                            <tr key={item.path}>
                                <td>{item.path}</td>
                                <td>{item.maxDuration}</td>
                                <td>{item.averageDuration}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            )}
        </div>
    );
};
